import styled from 'styled-components';
import {device} from '../../styled/device';

export const Preview = styled.div`
  position: relative;
  &:before {
    content: '';
    display: block;
    padding-bottom: 60.63%;

    @media (max-width: ${device.laptopL}) {
      padding-bottom: 64%;
    }

    @media (max-width: ${device.laptop}) {
      padding-bottom: 75%;
    }

    @media (max-width: ${device.tablet}) {
      display: none;
    }
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 80px 131px 80px 131px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: ${device.laptop}) {
    flex-direction: column;
    align-items: center;
    padding: 8px;
  }

  @media (max-width: ${device.tablet}) {
    position: relative;
  }

  @media (max-width: ${device.mobileXL}) {
    padding: 0;
  }
`;

export const BackImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  object-fit: cover;
`;
